import BookItem from "../common/bookItem";
import MutualSoundAfileGroupChild from "./mutual_sound_Afile_group_child"
import SentenceGroup from "../sound/sentence_group";
import { mouseEvent } from "../common/mouse_event";
export default class MutualSoundAfile extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.connectNumber = this.el.connectNumber;
        this.aGroup = [];
        this.soundGroups = [];
        this.targetAGroup = [];
        this.inPageTarget;
        this.isUsed = false;

        /**
         * 裝所有MutualSoundAfile按鈕
         */
        this.targetGroup = [];
        this.add_mouse_event();
        // mouseEvent.add_mouse_event(this);

    }

    init() {
        this.target.gotoAndStop(0);
        //陣列塞當頁ID , 朗讀的音檔條件判斷
        // this.itemControl.bookItems.forEach(element => {
        //     if (element instanceof SentenceGroup && (this.pageId == element.pageId || this.target.parent.parent.id == element.pageId)) {
        //         // console.log("elementid",element.pageId);
        //         this.soundGroup = element;
        //         // console.log("this.soundGroup++",this.soundGroup);
        //     }
        // });

        this.aGroup = this.itemControl.getItemsByClassConnect("mutualsoundAfilegroupchild", this);

        this.aGroup.forEach(element => {
            if (element.initialVisible == false) {
                this.targetAGroup.push(element);
            }
        });


        this.targetGroup = this.itemControl.getItemsByClassConnect("mutualsoundAfile", this);
        // 同編號且是在群組內-->音檔文字泡
        this.targetGroup.forEach(element => {
            if (element.itemControl.checkItemParent(element.target)) {
                this.inPageTarget = element;
            }
            else {
                this.inPageTarget = null;
            }
        });
    }

    trigger() {
        const self = this;
        // 陣列音檔開關觸碰 A檔開關可見度跟群組內子物件mouseEnabled

        self.aGroup.forEach(element => {
            // console.log("element.target", element.target);

            if (!element.target.visible) {

                //依序先把群組內物件觸碰打開
                element.target.children.forEach(element => {
                    element.mouseEnabled = true;
                });
            }
            else {
                //依序先把群組內物件觸碰關掉
                element.target.children.forEach(element => {
                    element.mouseEnabled = false;
                });
            }
            element.target.visible = !element.target.visible;
        });

        if(self.soundGroups.length == 0) {
            self.initSoundGroup();
        }

        // A檔關可見
        // console.log("self.soundGroup==", self.soundGroups);
        for(let i = 0 ; i < self.soundGroups.length; i++) {
            self.soundGroups[i].target.mouseEnabled = !self.targetAGroup[0].target.visible;

            self.soundGroups[i].recordchildren.forEach(element => {
                element.mouseEnabled = !self.targetAGroup[0].target.visible;
            });
        }

        //點的是群組類的-->文字泡
        if (!self.itemControl.checkItemParent(self.target)) {
            self.inPageTarget.isUsed = !self.inPageTarget.isUsed;
            self.inPageTarget.nowBtnIndex = self.inPageTarget.isUsed ? 1 : 0;
            self.inPageTarget.target.gotoAndStop(self.inPageTarget.nowBtnIndex);
            self.inPageTarget.itemControl.loader.singleAntialiasing(self.inPageTarget.target);
        }
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
            this.isUsed = !this.isUsed;
            this.nowBtnIndex = this.isUsed ? 1 : 0;
            this.target.gotoAndStop(this.nowBtnIndex);
        });
    }

    initSoundGroup() {
        this.soundGroups = this.itemControl.getItemsByClassPageId("sentenceGroup", this);
    }
}